import { ISO3166_ALPHA2_CODES } from "./iso3166Alpha2Codes";

export type CountryOption = {
  iso2: string;
  name: string;
};

function getIso2RegionCodesFromIntl(): string[] {
  const intl = Intl as unknown as { supportedValuesOf?: (key: "region") => string[] };
  if (typeof intl.supportedValuesOf !== "function") {
    return [];
  }
  try {
    return intl.supportedValuesOf("region").filter((c) => /^[A-Z]{2}$/.test(c));
  } catch {
    return [];
  }
}

export function getCountrySelectOptions(allowedIso2?: string[]): CountryOption[] {
  let codes = getIso2RegionCodesFromIntl();
  if (codes.length === 0) {
    codes = [...ISO3166_ALPHA2_CODES];
  }

  const filtered =
    allowedIso2 == null || allowedIso2.length === 0
      ? codes
      : codes.filter((c) => allowedIso2.some((a) => a.toUpperCase() === c.toUpperCase()));

  const displayNames = new Intl.DisplayNames(["en"], { type: "region" });

  return filtered
    .map((iso2) => ({ iso2, name: displayNames.of(iso2) ?? iso2 }))
    .sort((a, b) => a.name.localeCompare(b.name));
}
